import {RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainPageComponent } from './pages/main-page/main-page.component';
import { MgrabPageComponent } from './pages/mgrab-page/mgrab-page.component';
import { MscanPageComponent } from './pages/mscan-page/mscan-page.component';
import { MturnPageComponent } from './pages/mturn-page/mturn-page.component';
import { SetexPageComponent } from './pages/setex-page/setex-page.component';
import { AlcampoPageComponent } from './pages/alcampo-page/alcampo-page.component';
import { SkillsGridComponent } from './components/skills/skills-grid.component';
import { ValuesGridComponent } from './components/values/values-grid/values-grid.component';
import { ValueDetailComponent } from './components/values/value-detail/value-detail.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';
import { FlexTemplatePageComponent } from './pages/flex-template-page/flex-template-page.component';
import { DespinassePageComponent } from './pages/despinasse-page/despinasse-page.component';
import { CsrComponent } from './components/csr/csr.component';
import { CsrPageComponent } from 'src/app/pages/csr-page/csr-page.component';
import { McatalogPageComponent } from './pages/mcatalog-page/mcatalog-page.component';
import { MpayPageComponent } from './pages/mpay-page/mpay-page.component';
import { MhelpPageComponent } from './pages/mhelp-page/mhelp-page.component';
import { MbroadcastPageComponent } from './pages/mbroadcast-page/mbroadcast-page.component';
import { MecomPageComponent } from './pages/mecom-page/mecom-page.component';
import { McheckerPageComponent } from './pages/mchecker-page/mchecker-page.component';
import { MposPageComponent } from './pages/mpos-page/mpos-page.component';
import { MinventoryPageComponent } from './pages/minventory-page/minventory-page.component';


const routes: Routes = [
  { path: '', redirectTo: '/home/(values:values)', pathMatch: 'full'},
  { path: 'home', component: MainPageComponent, children: [
    { path: 'values', component: ValuesGridComponent, outlet: 'values' },
    { path: ':valueid', component: ValueDetailComponent, outlet: 'values' },
  ]},
  { path: 'csr', component: CsrPageComponent },
  { path: 'mGrab', component: MgrabPageComponent },
  { path: 'mScan', component: MscanPageComponent },
  { path: 'mTurn', component: MturnPageComponent },
  { path: 'mCatalog', component: McatalogPageComponent },
  { path: 'mBroadcast', component: MbroadcastPageComponent },
  { path: 'mEcom', component: MecomPageComponent },
  { path: 'mPay', component: MpayPageComponent },
  { path: 'mHelp', component: MhelpPageComponent },
  { path: 'mChecker', component: McheckerPageComponent },
  { path: 'mPos', component: MposPageComponent },
  { path: 'mInventory', component: MinventoryPageComponent },
  { path: 'setex', component: SetexPageComponent },
  { path: 'alcampo', component: AlcampoPageComponent },
  { path: 'flex_template', component: FlexTemplatePageComponent },
  { path: 'despinasse', component: DespinassePageComponent },
  { path: 'contact', component: ContactPageComponent }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forRoot(routes, {useHash: true, scrollPositionRestoration: 'top'})
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class AppRoutingModule { }
